var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Rest } from "../../Rest";
export class OmpApiLegacy extends Rest {
    constructor(baseUrl, tenantToken) {
        super(baseUrl);
        this.tenantToken = tenantToken;
        this.setCommonHeader("X-DES-AK-TENANT-TOKEN", this.tenantToken);
    }
    sendMessage(data, type = "CONTACT") {
        const { collection_point_token, consent_purposes, channel, user } = data, rest = __rest(data, ["collection_point_token", "consent_purposes", "channel", "user"]);
        const requestBody = JSON.stringify(Object.assign(Object.assign({ channel,
            user,
            collection_point_token,
            consent_purposes }, ((data === null || data === void 0 ? void 0 : data.email) && { data_subject: data.email })), { type, payload: rest }));
        return this.request("/forms", {
            headers: {
                "Content-Type": "application/json",
            },
            method: "POST",
            body: requestBody,
        }, true);
    }
}
//# sourceMappingURL=OmpApiLegacy.js.map